import { FeatureToggleClientService } from 'feature-toggle-client';
export const blipChatWidget = 'blip-chat-widget';
export class ChatFeatures {
    static isBlipChatWidgetEnabled() {
        return FeatureToggleClientService.getInstance()
            .isUserFeatureEnabled(blipChatWidget);
    }
}
